import type { JSX } from 'react/jsx-runtime'
import type { ProtectedRouteProps } from '@/types'
import { Navigate, useLocation } from 'react-router-dom'
import { routes } from '@/common/constants/routes'
import { useAuth } from '@/features/auth/hooks/use-auth'

// ...existing code...

const ProtectedRoute = ({ children }: ProtectedRouteProps): JSX.Element => {
  const { isLoading, user } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div
        className="
          flex min-h-screen items-center justify-center bg-white
          dark:bg-gray-950
        "
      >
        <div className="flex flex-col items-center gap-4">
          <div
            className="
              size-12 animate-pulse rounded-2xl bg-teal-100
              dark:bg-teal-900/30
            "
          />
          <div
            className="
              h-4 w-32 animate-pulse rounded-lg bg-gray-100
              dark:bg-gray-800
            "
          />
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate replace state={{ from: location }} to={routes.LOGIN} />
  }

  return <>{children}</>
}

export { ProtectedRoute }
